import React, {useState, createContext, useContext} from "react";

const AudioContext = createContext();

export default function AudioProvider({ children }) {
  const [audio, setAudio] = useState({
    id: "",
    thumbNail: "",
    title: "",
    isPaused: true,
    currentTime: "0:00",
    duration: "0:00"
  });

  return <AudioContext.Provider value={{audio, setAudio}}>{children}</AudioContext.Provider>;
}

export function useAudio(){
  const {audio, setAudio} = useContext(AudioContext);
  return {audio, setAudio};
}
